import { inject, Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { PROVIDER_BRANDS } from '../consts/provider-brand.const';
import { Doctor } from '../models/doctor.model';
import { Patient } from '../models/patient.model';

export type User = Doctor | Patient;

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly requestService = inject(RequestService);

  getMe<T>(): Promise<T> {
    return this.requestService.get('/me');
  }

  getLadLogo(user?: User): string {
    // If user does not exist or is a doctor, return the default logo
    if (!user || user.type === 0) {
      return 'assets/lad_logo_es.svg';
    }

    switch ((user as Patient).provider?.brand) {
      case PROVIDER_BRANDS.LAD_PT:
        return 'assets/lad_logo_pt.svg';
      case PROVIDER_BRANDS.LAD_EN:
        return 'assets/lad_logo_en.svg';
      default:
        return 'assets/lad_logo_es.svg';
    }
  }
}
